import { useTranslations } from '@vocab/react';
import {
  Actions,
  Alert,
  Button,
  ButtonLink,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import appTranslations from 'src/App/App.vocab';
import { BASE_URL } from 'src/constants/urls';
import { useConfig } from 'src/modules/ConfigProvider';

import TrackingLink from '../../TrackingLink/TrackingLink';

interface CancelButtonData {
  analytics: string;
  analyticsOrigin?: string;
}

interface FormActionsProps {
  cancelButtonData: CancelButtonData;
  displayGenericFormError: boolean;
  genericErrorMessage: string;
  submitButtonText: string;
  submitButtonLoading: boolean;
}

export const FormActions = ({
  cancelButtonData,
  displayGenericFormError,
  genericErrorMessage,
  submitButtonText,
  submitButtonLoading,
}: FormActionsProps) => {
  const { urlResolver } = useConfig();
  const { t: appTrans } = useTranslations(appTranslations);

  return (
    <Stack space="medium">
      {displayGenericFormError && (
        <Alert tone="critical">
          <Text>{genericErrorMessage}</Text>
        </Alert>
      )}
      <Actions>
        <Button type="submit" tone="formAccent" loading={submitButtonLoading}>
          {submitButtonText}
        </Button>
        <TrackingLink
          renderAs={ButtonLink}
          variant="transparent"
          href={urlResolver({ path: `/${BASE_URL}` })}
          data-analytics={cancelButtonData.analytics}
          data-analytics-origin={cancelButtonData.analyticsOrigin}
        >
          {appTrans('Cancel button')}
        </TrackingLink>
      </Actions>
    </Stack>
  );
};
